// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState } from 'react';
import styled from 'styled-components';

const WIDTH = 40;
const HEIGHT = 40;

const StyledMarker = styled.div`
  position: absolute;
  left: ${-WIDTH / 2}px;
  top: ${-HEIGHT / 2}px;

  img {
    :hover,
    :focus {
      outline: none;
      border: none;
      box-shadow: none;
    }
  }
`;

const StyledInfoBlock = styled.div`
  position: absolute;
  top: ${HEIGHT}px;
  left: -70px;
  width: 200px;

  padding: 6px;
  padding-right: 15px;
  background: #ffffff;
  color: #000000;
  cursor: auto;
  i {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
    z-index: 10;
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const ActivityLocationFieldMarker = ({ address }) => {
  const [infoShown, setInfoShown] = useState(true);

  const onCloseIconClick = event => {
    event.stopPropagation();
    setInfoShown(false);
  };

  return (
    <StyledMarker title={address} onClick={() => setInfoShown(!infoShown)}>
      <img src='/favicon.ico' alt='B' />
      {infoShown && (
        <StyledInfoBlock>
          {address}
          <i className='fas fa-times' onClick={onCloseIconClick} />
        </StyledInfoBlock>
      )}
    </StyledMarker>
  );
};

export default React.memo(ActivityLocationFieldMarker);
